import { GetImageTitlesParamsType } from '@/common/queries/selections/ImageTitles/getImageTitlesQuery.type';
import { getImageTitlesFunction } from '@/common/queries/selections/ImageTitles/getImageTitlesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getImageTitlesQueryOptions = (
  params: GetImageTitlesParamsType,
) => {
  return queryOptions({
    queryKey: ['VehiclePart', params],
    queryFn: () => getImageTitlesFunction(params),
    select: (data) =>
      data.map((item) => ({
        label: item.fa_const,
        value: item.fa_const,
        enNameOrId: item.const,
      })),
  });
};
